export const SET_TOKEN_FROM_IFRAME = 'setTokenFromIframe';
export const RELOAD_WORKFLOW_ACTION_CONTEXT_NODE = 'reloadWorkflowActionContextNode';
